/**
 * Locale 聚合器 —— 把主字典 + 共用 namespace 合併成一份 messages，
 * 給 vue-i18n / postMessage 推 shared-web 共用。
 *
 * 結構：
 *   messages.<locale> = {
 *     ...mainDict,             // 既有 host UI / paytable.* / rules.* / history.* ...
 *     common: { ... },         // 跨遊戲共用 key（button / section / unit / symbol）
 *   }
 *
 * 主字典是 AUTO-GENERATED，不要手動修改。
 *
 * 遊戲專屬內容（HBFY 等）已從 locale 移出，改放在 src/games/<gameId>/content.ts
 * 用 I18nText 物件單一檔承載多語言，由各 game modal 直接 import 消費。
 * vue-i18n 在這專案只負責 host UI 共用詞（modal 標題、按鈕、共用符號名）。
 */

import enMain from './en'
import zhMain from './zh'
import enCommon from './common/en'
import zhCommon from './common/zh'

export const messages = {
  en: {
    ...enMain,
    common: enCommon,
  },
  zh: {
    ...zhMain,
    common: zhCommon,
  },
} as const

export type Messages = typeof messages
